import React, { useEffect, useState } from 'react';
import { Table, Row, Col, Card, CardBody, CardTitle, CardHeader, Button, Form, Input } from 'reactstrap';
import PropTypes from 'prop-types';
import { useSelector , useDispatch } from 'react-redux';
import Loader from '../../../components/common/Loader';
import { connect } from 'react-redux';
import { getVoices, countvoices, voiceSearch, countfiltervoice } from '../../../Redux/Actions/USER/user';
import Pagination from 'react-js-pagination';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Label from 'reactstrap/lib/Label';
import Tooltipbutton from '../../../components/Tooltip/Tooltip';
import './pagenation.css';
import { FaWandMagicSparkles } from 'react-icons/fa6';
import LogsChatAssistantBox from './LogsChatAssistantBox'; 
import { openLogsChat } from '../../../Redux/Reducer/logsChatAssistant';

var moment = require('moment-timezone');
const UserVoice = ({
  getVoices,
  voices,
  countvoices,
  count,
  searchData,
  voiceSearch,
  search,
  inboundcheck,
  outboundcheck,
  countfiltervoice
}) => {
  const [offset, setoffset] = useState(0);
  const [activePage, setactivePage] = useState(0);
//  const [logChatOpen, setLogChatOpen] = useState(false);
// const [logChatSessionId, setLogChatSessionId] = useState('');
// const [logChatPhone, setLogChatPhone] = useState('')

const dispatch = useDispatch();


const normalizeE164 = (n) => {
  if (!n) return '';
  const s = String(n).trim();
  return s.startsWith('+') ? s : `+${s.replace(/^\+/, '')}`;
};

  const currtz = useSelector(state => state.Twilio.timezone);
  useEffect(() => {
    getVoices(offset);
    countvoices();
  }, []);
  useEffect(() => {
    console.log("voices=================",voices)
  }, [voices]);
  useEffect(() => {
    if (search) {
      setoffset(0);
      let ss = search.startsWith('+') ? search.substr(1) : search;
      voiceSearch(ss, outboundcheck, inboundcheck, 0);
      countfiltervoice(outboundcheck, inboundcheck, search);
    } else if (inboundcheck || outboundcheck) {
      setoffset(0);
      getVoices(offset, inboundcheck, outboundcheck);
      countfiltervoice(outboundcheck, inboundcheck, search);
    } else {
      getVoices(offset, inboundcheck, outboundcheck);
      countvoices();
    }
  }, [search, outboundcheck, inboundcheck]);
  useEffect(() => {
    setactivePage(0);
  }, [outboundcheck, inboundcheck]);

  const handlePageChange = pageNumber => {
    let off = pageNumber * 10 - 10;
    setactivePage(pageNumber);

    if (search) {
      let ss = search.startsWith('+') ? search.substr(1) : search;
      voiceSearch(ss, outboundcheck, inboundcheck, off);
    } else getVoices(off, inboundcheck, outboundcheck);
  };
  // console.log({ voices });
  if (voices === null || voices.length === 0) {
    return (
      <Row className="justify-content-center">
        <Col sm="12">
          <Card>
            <CardBody>
              <Label style={{ display: 'flex', justifyContent: 'center' }}>No Log Present</Label>
            </CardBody>
          </Card>
        </Col>
      </Row>
    );
  }

  

  return (
    <Row className="justify-content-center">
      <Col md="12" sm="12">
        <Card>
          <CardBody>
            <Row>
         
            </Row>

            <Table responsive bordered striped hover>
              <thead>
                <tr>
                  <th>SNo.</th>
                  <th>From</th>
                  <th>To</th>
                  <th style={{width: 80, textAlign: 'center'}}>✨🤖AI Assistant</th>
                  <th>Record Link</th>
                  <th>Status</th>
                  <th>Charge</th>
                  <th>Direction</th>
                  <th>Duration</th>
                  <th>Time</th>
                </tr>
              </thead>
              <tbody>
                {voices.length &&
                  voices.map((item, index) => (
                    <tr key={item._id}>
                      <th scope="row">{index + 1}</th>
                      <td>{item.from}</td>
                      <td
                        style={{ maxWidth: '16ch', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}
                      >
                        {item.to.startsWith('client') ? '+' + item.calledvia : item.to}
                      </td>
                                         <td style={{ textAlign: 'center' }}>
                     <button
                       title="Open AI Chat (Magic Wand)"
                      //  onClick={() => {
                      //    // Session id = Twilio CallSid (sid) — fallback to psid if present
                      //    const sid = item.sid || item.psid;
                      //    // Determine number for initial query:
                      //    const isOutbound = item.direction === 'outbound-dial';
                      //    let phone;
                      //    if (isOutbound) {
                      //      // Outbound: prefer 'to'; if it's a "client:*", use calledvia; also normalize to +E.164 if missing '+'
                      //      if (item.to && item.to.startsWith('client')) {
                      //        phone = item.calledvia ? `+${String(item.calledvia).replace(/^\+/, '')}` : '';
                      //      } else {
                      //        phone = item.to ? (item.to.startsWith('+') ? item.to : `+${item.to}`) : '';
                      //      }
                      //    } else {
                      //      // Inbound: use 'from' as-is
                      //      phone = item.from || '';
                      //    }
                      //    setLogChatSessionId(sid || '');
                      //    setLogChatPhone(phone || '');
                      //    setLogChatOpen(true);
                      //  }}


                       onClick={() => {
   const sid = item.sid || item.psid;
   const isOutbound = item.direction === 'outbound-dial';

   // Compute phone used for seed query (your existing logic):
   let phone;
   if (isOutbound) {
     if (item.to && item.to.startsWith('client')) {
      phone = normalizeE164(item.calledvia || '');
     } else {
      phone = normalizeE164(item.to || '');
     }
   } else {
    phone = normalizeE164(item.from || '');
   }

  // Compute explicit to/from to send to API every time:
  // For Twilio logs, when "to" shows "client:*", the real dialed number is usually "calledvia".
  const toNumber = (item.to && item.to.startsWith('client'))
    ? normalizeE164(item.calledvia || '')
    : normalizeE164(item.to || '');

  const fromNumber = normalizeE164(item.from || '');

  dispatch(openLogsChat({
    sessionId: sid || '',
    phone: phone || '',
    to: toNumber,
    from: fromNumber
  }));
 }}


//                       onClick={() => {
//   const sid = item.sid || item.psid;
//   const isOutbound = item.direction === 'outbound-dial';
//   let phone;

//   if (isOutbound) {
//     if (item.to && item.to.startsWith('client')) {
//       phone = item.calledvia ? `+${String(item.calledvia).replace(/^\+/, '')}` : '';
//     } else {
//       phone = item.to ? (item.to.startsWith('+') ? item.to : `+${item.to}`) : '';
//     }
//   } else {
//     phone = item.from || '';
//   }

//   dispatch(openLogsChat({ sessionId: sid || '', phone: phone || '' }));
// }}
                       style={{
                         width: 36, height: 36, borderRadius: '50%', border: 'none', cursor: 'pointer',
                         background: 'linear-gradient(135deg, #6366f1 0%, #22d3ee 100%)',
                         boxShadow: '0 8px 18px rgba(0,0,0,0.18), inset 0 0 10px rgba(255,255,255,0.22)',
                         display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                         color: '#fff',
                         outline: 'none',
                         WebkitTapHighlightColor: 'transparent'
                       }}
                       className="ai-wand-btn"
                     >
                       <FaWandMagicSparkles size={16} />
                     </button>
                   </td>
                      <td>
                        {item.RecordingUrl ? (
                          <Tooltipbutton title="Click and listen to the call recording">
                            <div
                              className="btn btn-trans btn-other btn-sm"
                              onClick={() => {
                                window.open(item.RecordingUrl);
                              }}
                            >
                              <i class="far fa-play-circle" />
                              &nbsp; Click
                            </div>
                          </Tooltipbutton>
                        ) : null}
                      </td>
                      <td>{item.status.charAt(0).toUpperCase() + item.status.slice(1)}</td>
                      <td>{item.charges != undefined ? `$${item.charges.toFixed(3)}` : 0}</td>
                      <td>
                        {item.direction == 'outbound-dial' ? (
                          <div className="btn btn-trans btn-outbound btn-sm ">
                            <i className="material-icons">call_made</i> Outbound
                          </div>
                        ) : (
                          <div className="btn btn-trans btn-inbound btn-sm ">
                            <i className="material-icons">call_received</i>
                            {item.direction && item.direction.charAt(0).toUpperCase() + item.direction.slice(1)}
                          </div>
                        )}
                      </td>
                      <td>{item.duration ? item.duration + 'sec' : null}</td>
                      <td style={{ whiteSpace: 'nowrap' }}>
                        {moment(item.createdAt)
                          .tz(currtz)
                          .format('LLL')}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
            <Row className="mt-4">
              <Col xs="12">
                <Pagination
                  activePage={activePage}
                  itemsCountPerPage={10}
                  totalItemsCount={count}
                  pageRangeDisplayed={3}
                  onChange={handlePageChange}
                />
              </Col>
        
            </Row>
          </CardBody>
        </Card>
      </Col>
         {/* Logs Chat Panel */}
     {/* <LogsChatAssistantBox
       isOpen={logChatOpen}
       onClose={() => setLogChatOpen(false)}
       sessionId={logChatSessionId}
       phoneForQuery={logChatPhone}
     /> */}
    </Row>
  );
};
const mapStateToProps = state => ({
  voices: state.Twilio.voices,
  count: state.Twilio.voicecount,
  searchData: state.Twilio.searchData
});
UserVoice.propTypes = {
  getVoices: PropTypes.func.isRequired
};
export default connect(
  mapStateToProps,
  { getVoices, countvoices, voiceSearch, countfiltervoice }
)(UserVoice);
